import { getLocale } from "../utils/utils";

/**
 * 双模式配置读取：
 * - 生产环境（WordPress）：通过 WordPress PHP 模板在 index.html 中注入 window._ENV_
 * - 本地开发：通过 .env.local 文件设置 REACT_APP_* 环境变量（不提交到 git）
 */
const runtimeConfig = window._ENV_ || {};

const isPlaceholder = (val) => !val || val.startsWith("__");

const api_key = isPlaceholder(runtimeConfig.API_KEY)
  ? (process.env.REACT_APP_API_KEY || "")
  : runtimeConfig.API_KEY;

const token = isPlaceholder(runtimeConfig.TOKEN)
  ? (process.env.REACT_APP_TOKEN || "")
  : runtimeConfig.TOKEN;

const baseURL = isPlaceholder(runtimeConfig.BASE)
  ? (process.env.REACT_APP_BASE || "")
  : runtimeConfig.BASE;

// 语言/地区根据域名和 URL path 自动判断（复用 getLocale）
const locale = getLocale();
const lang = locale;
const region = locale === "cn" ? "cn" : null;

export { api_key, token, lang, baseURL, locale, region };
